import { Bundle } from '@ali/visualengine';
import React from 'react';
import Icon from './logo.tsx';
import {
  createButtonListSetters,
  getItem,
} from '@/common/manager/button';
import { ButtonPosition } from '@/common/manager/position/button-position';
import {
  getDataOriginSetterSnippet,
  getDataSetterSnippet,
  getHandlePropsSetterSnippet,
  getJSXTemplate,
  getMixedSetterSnippet,
  getRequestConfigSetterSnippet,
  getStaticDataSourceSnippet,
} from '@/common/manager/setter-snippet';
import { getJSExpressionPrototype } from '@/common/manager/common-style';
import { condition } from '@/common/util/util';
import {
  dataOriginStatic,
  dataOriginRequest,
} from '@/common/util/const';
import { createEventSetters } from '@/common/manager/event';
import { createDataSourceSetters } from '@/lowcode/cn-form-alc/prototype/form-item';

const CnEntryPointsBundle = Bundle.createPrototype({
  title: '入口组件（CnEntryPoints）',
  componentName: 'CnEntryPoints',
  category: '数据展示',
  icon: Icon,
  docUrl:
    'https://cone.cainiao-inc.com/market/awesome?business=internationality&id=3313',
  isContainer: false,
  canHovering: true,
  canSelecting: true,
  canDragging: true,
  enableCopy: true,
  snippets: [
    {
      screenshot:
        'https://img.alicdn.com/imgextra/i2/O1CN01BFUrQN1ySmB4kHp98_!!6000000006578-0-tps-1276-302.jpg',
      label: 'CnEntryPoints',
      schema: {
        componentName: 'CnEntryPoints',
        props: {},
      },
    },
  ],
  configure: [
    {
      name: 'isCnEntryPoints',
      title: 'isCnEntryPoints',
      initialValue: true,
      display: 'none',
    },
    {
      name: '_context',
      title: '上下文',
      initialValue: {
        type: 'JSExpression',
        value: 'this',
      },
      display: 'none',
    },
    ...getDataSetterSnippet(),
    ...createEventSetters({
      position: ButtonPosition.entryPointEvent,
      initialValue: {
        // optType: 'setFormStepCurrent'
      },
      title: '配置入口点击的回调',
    }),
    {
      title: '高级配置',
      type: 'group',
      collapsed: true,
      display: 'accordion',
      items: [
        {
          name: 'handleProps',
          title: '手动设置组件props',
          display: 'inline',
          setter: getJSExpressionPrototype({
            type: 'props',
          }),
        },
      ],
    },
  ],
});

export default CnEntryPointsBundle;
